import { onlyDateFromServer } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { IAccountOrderDto } from '@/dtos';
import { AccountOrder } from '@/modules/UseMyMoney/queries';

export const formatAccountOrder = (accountOrder: IAccountOrderDto, index: number): AccountOrder => ({
  index: toString(index),
  accountId: toString(accountOrder?.account_id),
  order: accountOrder?.order,
  planName: accountOrder?.plan_name,
  accountType: accountOrder?.account_type,
  availableBalance: accountOrder?.available_balance,
  submitClaimsDateEnd: accountOrder?.submit_claims_date_end
    ? onlyDateFromServer(`${accountOrder?.submit_claims_date_end}`)
    : undefined,
  isForfeited: accountOrder?.is_forfeited,
  services: accountOrder?.services
    ?.filter((service) => !!service?.name)
    ?.map((service) => ({
      id: toString(service?.id),
      name: service?.name || '',
      categoryType: service?.category_type,
    })),
  coveragePeriods: accountOrder?.coverage_periods?.map((coveragePeriod) => ({
    coverageDateStart: toString(coveragePeriod?.coverage_date_start),
    coverageDateEnd: toString(coveragePeriod?.coverage_date_end),
  })),
});
